<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <form @submit.prevent>
          <div class="modal-container child">
            <div class="modal-header"><h3>Export</h3></div>
            <div class="modal-body">
              <div class="form-group row">
                <div class="col-xs-18">
                  <textarea
                    id="export"
                    v-model="exportFormat"
                    rows="10"
                    cols="200"
                    readonly
                    name="export"
                    class="form-control form-control-sm"/>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="modal-default-button btn btn-default"
                @click="$emit('close')">
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters, } from 'vuex';

export default {
	// eslint-disable-next-line vue/require-prop-types
	props: ['labels', 'languages', 'groups',],
	data() {
		return {
			hasErrors: false,
		};
	},
	computed: {
		...mapGetters(['cart',]),
		exportFormat() {
			let jsonFormat = {};

			for (let i in this.cart.languages) {
				let langDet = this.languages.find(
					(eachLanguage) => eachLanguage.id === this.cart.languages[i]
				);

				if (langDet) {
					jsonFormat[langDet.name] = {};
					for (let j in this.cart.labels) {
						let labDet = this.labels.find(
							(eachLabel) => eachLabel.id === this.cart.labels[j]
						);
						if (labDet) {
							let trans = labDet.translations.find(
								(eachTrans) =>
									eachTrans.language.id === langDet.id
							);
							jsonFormat[langDet.name][labDet.name] =
								trans && trans.value ? trans.value : '';
						}
					}
				}
			}
			return JSON.stringify(jsonFormat, null, 4);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ModalExport.vue